import { compact } from "lodash-es";

import { decodeAgentDisplayText } from "@/pages/agent/utils/agent-display-text.utils";

export const buildAgentSearchableText = ({
  values,
}: {
  values: Array<string | null | undefined>;
}) =>
  compact(values)
    .map(value => decodeAgentDisplayText({ value }))
    .join(" ")
    .toLowerCase();
